/**
 * @generated SignedSource<<90c283d37d26a566350d43c932658acb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventHostsFormFields_Occurrence$data = {
  readonly hosts: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly organizationMembershipId: string;
        readonly productMembershipId: string | null;
      };
    }>;
  };
  readonly " $fragmentType": "EventHostsFormFields_Occurrence";
};
export type EventHostsFormFields_Occurrence$key = {
  readonly " $data"?: EventHostsFormFields_Occurrence$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventHostsFormFields_Occurrence">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventHostsFormFields_Occurrence",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OccurrenceHostNodeConnection",
      "kind": "LinkedField",
      "name": "hosts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OccurrenceHostNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OccurrenceHost",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "productMembershipId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "organizationMembershipId",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Occurrence",
  "abstractKey": null
};

(node as any).hash = "7d62fda50b4951afb487ba95aacbf887";

export default node;
